import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/transaction-requests/")({
  beforeLoad: () => {
    // Redirect to transactions page with waiting tab and forApproval filter
    throw redirect({
      to: "/dashboard/transactions",
      search: {
        tab: "waiting" as const,
        forApproval: true,
        page: 1,
        pageSize: 10,
        search: "",
        sortBy: "createdAt",
        sortOrder: "desc" as const,
      },
    });
  },
});

